export class CreatePipelineTrackers {
  /**
   * Wizard
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_WIZARD_BACK_CLICK =
    '[Pipelines] create pipeline wizard back click';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_WIZARD_CANCEL_CLICK =
    '[Pipelines] create pipeline wizard cancel click';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_WIZARD_STEP_CLICK =
    '[Pipelines] create pipeline wizard step click';

  /**
   * Select Source Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SELECT_SOURCE_TYPE =
    '[Pipelines] create pipeline select source type';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SELECT_EXISTING_SOURCE =
    '[Pipelines] create pipeline select existing source';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_CREATE_NEW_SOURCE_RADIO_CLICK =
    '[Pipelines] create pipeline create new source radio click';

  /**
   * Source Settings Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SOURCE_SETTINGS_CREATED_NEW_SOURCE =
    '[Pipelines] create pipeline source settings created new source';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SOURCE_SETTINGS_CONFIGURED_EXISTING_SOURCE =
    '[Pipelines] create pipeline source settings configured existing source';

  /**
   * Select Destination Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SELECT_DESTINATION_TYPE =
    '[Pipelines] create pipeline select destination type';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_SELECT_EXISTING_DESTINATION =
    '[Pipelines] create pipeline select existing destination';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_CREATE_NEW_DESTINATION_RADIO_CLICK =
    '[Pipelines] create pipeline create new destination radio click';

  /**
   * Destination Settings Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_DESTINATION_SETTINGS_CREATED_NEW_DESTINATION =
    '[Pipelines] create pipeline destination settings created new destination';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_DESTINATION_SETTINGS_CONFIGURED_EXISTING_DESTINATION =
    '[Pipelines] create pipeline destination settings configured existing destination';

  /**
   * Pipeline Settings Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_PIPELINE_SETTINGS_SAVED_CONFIGURATION =
    '[Pipelines] create pipeline pipeline settings saved configuration';

  /**
   * Object Config Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_OBJECT_CONFIG_SAVED_CONFIGURATION =
    '[Pipelines] create pipeline object configuration saved configuration';

  /**
   * Review Step
   * */
  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_SUBMIT_CLICK =
    '[Pipelines] create pipeline review submit click';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_SUCCESS =
    '[Pipelines] create pipeline review success';

  static readonly PIPELINE_TRACKER_CREATE_PIPELINE_REVIEW_FAILURE =
    '[Pipelines] create pipeline review failure';
}
